import { render } from "./autoshipOpen.vue?vue&type=template&id=64c3f4a8&scoped=true"
import script from "./autoshipOpen.vue?vue&type=script&lang=js"
export * from "./autoshipOpen.vue?vue&type=script&lang=js"

import "./autoshipOpen.vue?vue&type=style&index=0&id=64c3f4a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c3f4a8"]])

export default __exports__